import React, { useState, useEffect } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import api from "../../api";
import "../../styles/GiftRedeem.css";
import "../../styles/buttons.css";

export default function GiftRedeemPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();

  const [code, setCode] = useState(params.get("code") || "");
  const [email, setEmail] = useState("");
  const [pwd, setPwd] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  // For the emoji confetti effect:
  const [confetti, setConfetti] = useState([]);

  // Only valid if all fields are filled and passwords match
  const valid =
    code.trim() !== "" &&
    email.trim() !== "" &&
    pwd !== "" &&
    pwd === confirm;

  // Redeem handler
  const redeem = async () => {
    if (!valid) return;
    setLoading(true);
    setError("");

    try {
      await api.post(
        "/gift/redeem",
        {
          code: code.trim(),
          email: email.trim(),
          password: pwd
        },
        { withCredentials: true }
      );
      navigate("/signin?gift=success");
    } catch (err) {
      setError(
        err?.response?.data?.message || "Redemption failed. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const EMOJIS = ["🎈", "🎊", "🥳", "🎉"];
    const arr = Array.from({ length: 60 }).map((_, i) => ({
      id: i,
      left: Math.random() * 100 + "%",
      delay: Math.random() * 2 + "s",
      duration: Math.random() * 3 + 4 + "s",
      emoji: EMOJIS[Math.floor(Math.random() * EMOJIS.length)],
      size: (Math.random() * 2 + 2) + "rem",
    }));
    setConfetti(arr);

    const timer = setTimeout(() => setConfetti([]), 8000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="gift-redeem-body">
      {confetti.map((c) => (
        <span
          key={c.id}
          className="emoji-confetti"
          style={{
            left: c.left,
            animationDelay: c.delay,
            animationDuration: c.duration,
            fontSize: c.size,
          }}
        >
          {c.emoji}
        </span>
      ))}

      <div className="logo">
        <Link to="/">BestDay2Marry</Link>
      </div>
      <div className="gift-redeem-container">
        <div className="gift-redeem-card">
          <h1>Redeem Your Gift and Create Your Account</h1>
          <p>
            Enter your code, email and password you would like to use. You will
            be navigated to the login page after creating your account.
          </p>

          <div className="form-group">
            <label>Gift Code</label>
            <input
              type="text"
              value={code}
              onChange={(e) => setCode(e.target.value.trim())}
              className={
                code.trim() === "" && !loading ? "error-field" : ""
              }
            />
          </div>

          <div className="form-group">
            <label>Email Address</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className={
                email.trim() === "" && !loading ? "error-field" : ""
              }
            />
          </div>

          <div className="form-group">
            <label>Password</label>
            <input
              type="password"
              value={pwd}
              onChange={(e) => setPwd(e.target.value)}
              className={pwd === "" && !loading ? "error-field" : ""}
            />
          </div>

          <div className="form-group">
            <label>Confirm Password</label>
            <input
              type="password"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              className={confirm !== pwd && !loading ? "error-field" : ""}
            />
          </div>

          {error && (
            <div className="error-message gift-redeem__error">{error}</div>
          )}

          <button
            className="btn btn-primary gift-redeem__submit"
            disabled={!valid || loading}
            onClick={redeem}
          >
            {loading ? "Redeeming…" : "Create My Account"}
          </button>
        </div>
      </div>
    </div>
  );
}